export default __webpack_public_path__ + "static/Aime-Thin-8f966e1e7545d85a10148b9e3101d769.woff2";